export interface TraceData {
  operation: string;
  data?: any;
  scope?: string;
  sessionId?: string;
  timestamp?: string;
}

export const recordTrace = async (
  operation: string, 
  data?: any, 
  scope?: string, 
  sessionId?: string
): Promise<void> => {
  if (typeof window !== 'undefined') {
    const traceData = {
      operation,
      data,
      scope,
      sessionId,
      timestamp: new Date().toISOString()
    };
    
    console.log('[Browser Trace]', traceData);
    
    try {
      const traces = JSON.parse(sessionStorage.getItem('hive-traces') || '[]');
      traces.push({
        id: crypto.randomUUID(),
        ...traceData
      });
      
      if (traces.length > 100) {
        traces.splice(0, traces.length - 100);
      }
      
      sessionStorage.setItem('hive-traces', JSON.stringify(traces));
    } catch (error) {
      console.warn('Failed to store trace in sessionStorage:', error);
    }
  }
};

export const getTraces = (): TraceData[] => {
  if (typeof window === 'undefined') return [];
  
  try {
    return JSON.parse(sessionStorage.getItem('hive-traces') || '[]');
  } catch {
    return [];
  }
};

export const clearTraces = (): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem('hive-traces');
  }
};

export const summarize = async (data: any): Promise<any> => {
  return {
    totalFiles: Array.isArray(data) ? data.length : 1,
    totalIssues: data?.issues?.length || 0,
    fixedIssues: data?.fixes?.length || 0,
    summary: 'Browser-compatible summary generated'
  };
};

export const getInsights = async (scope: string): Promise<any[]> => {
  console.log(`Getting insights for scope: ${scope}`);
  return [
    { pattern: 'common-pattern-1', frequency: 0.8 },
    { pattern: 'common-pattern-2', frequency: 0.6 },
    { pattern: 'common-pattern-3', frequency: 0.4 }
  ];
};
